const bookingsRoutes = {
  path: "bookings",

  // Lazy-load the layout
  lazy: async () => {
    const mod = await import("components/UI/BookingsLayout");
    const BookingsLayout = mod.default;
    return { Component: BookingsLayout };
  },

  children: [
    {
      path: "links",
      lazy: async () => {
        const mod = await import("views/Admin/Bookings");
        const Bookings = mod.default;
        return { Component: Bookings };
      },
    },
    {
      path: "mybookings",
      lazy: async () => {
        const mod = await import("views/Admin/Bookings/Mybookings");
        const Mybookings = mod.default;
        return { Component: Mybookings };
      },
    },
  
    // {
    //   path: "not-booking",
    //   lazy: async () => {
    //     const mod = await import("views/Admin/Bookings/EmailStudio");
    //     const EmailStudio = mod.default;
    //     return { Component: EmailStudio };
    //   },
    // },
  ],
};

export default bookingsRoutes;
